import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { HubListFacade } from './hub-list.facade';

@Injectable({
  providedIn: 'root',
})
export class HubListGuard {
  constructor(private hubListFacade: HubListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.hubListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubListFacade);
  }
}
